export enum AreaType {
    CITY = 'city',
    STATE = 'state',
    ZIP = 'zip'
}
